<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1">
    <router-outlet></router-outlet>
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
